import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { NOTIFICATION_MODULE_NAMESPACE, NOTIFICATION_GET_NOTIFICATIONS, NOTIFICATION_GET_UNREAD_NOTIFICATIONS, NOTIFICATION_MARK_ALL_AS_READ, NOTIFICATION_DELETE_ALL, NOTIFICATION_UPDATE_GET_NOTIFICATION_PARAMETER, NOTIFICATION_GET_NOTIFICATION_INFINITY_LOADING, NOTIFICATION_GET_UNREAD_NOTIFICATION_INFINITY_LOADING, NOTIFICATION_UPDATE_GET_UNREAD_NOTIFICATION_PARAMETER, NOTIFICATION_MARK_AS_READ_BY_ID } from '../../store/notification';
import { IHeaderNotification, HeaderNotification, INotificationParameter } from '../../models/generic';
import * as _ from "lodash";
import moment = require('moment');
import {ActivityStatus} from '../../common/enums';
import { TICKET_MODULE_NAMESPACE, TICKET_INIT_UNREAD_MESSAGE } from '../../store/ticket';
import {AUTHORIZATION_FUNCTIONALITIES, AUTHORIZATION_MODULE_NAMESPACE} from '../../store/authorization';
const NotificationStore = namespace(NOTIFICATION_MODULE_NAMESPACE)
const TicketStore= namespace(TICKET_MODULE_NAMESPACE)
const AuthorizationStore = namespace(AUTHORIZATION_MODULE_NAMESPACE)

@Component({
  components: {
    'v-infinite-loading': async () => import('vue-infinite-loading'),
    'notification-item': async () => import("../header-notifications-item/HeaderNotificationsItem.vue")
  }
})
class Container extends Vue {
  dtPreviousDateText: string | null;

  dtActiveTab: number
  dtActiveTabs: number[]
  dtIsDeleting: boolean
  dtIsMarkasReadLoading: boolean

  @Prop({ default: false, type: [Boolean], required: false })
  visible: boolean


  @NotificationStore.Action(NOTIFICATION_GET_UNREAD_NOTIFICATIONS)
  storeGetUnreadNotifications: () => Promise<any>
  @NotificationStore.Action(NOTIFICATION_GET_NOTIFICATIONS)
  storeGetNotifications: () => Promise<any>
  @NotificationStore.Action(NOTIFICATION_MARK_ALL_AS_READ)
  storeMarkAllAsRead: () => Promise<any>
  @NotificationStore.Action(NOTIFICATION_DELETE_ALL)
  storeDeleteAll: () => Promise<any>

  @NotificationStore.Mutation(NOTIFICATION_UPDATE_GET_NOTIFICATION_PARAMETER)
  storeUpdateGetNotificationsSearchParameter: (skipNumber?: number) => void
  @NotificationStore.Mutation(NOTIFICATION_UPDATE_GET_UNREAD_NOTIFICATION_PARAMETER)
  storeUpdateGetUnreadNotificationsSearchParameter: (skipNumber?: number) => void

  @NotificationStore.Action(NOTIFICATION_GET_NOTIFICATION_INFINITY_LOADING)
  storeGetNotificationsLoadMore: () => void
  @NotificationStore.Action(NOTIFICATION_GET_UNREAD_NOTIFICATION_INFINITY_LOADING)
  storeGetUnreadNotificationsLoadMore: () => void
  @NotificationStore.Action(NOTIFICATION_MARK_AS_READ_BY_ID)
  storeUpdateReadForSingleItem: (id: string) => void

  @TicketStore.Mutation(TICKET_INIT_UNREAD_MESSAGE)
  storeTicketInitUnreadMessages: () => void

  @NotificationStore.Getter notifications: {
    scrollable?: boolean
    notifications: IHeaderNotification[]
    activityStatus: ActivityStatus
    searchParameter: INotificationParameter
  }
  @NotificationStore.Getter unreadNotifications: {
    scrollable?: boolean
    notifications: IHeaderNotification[]
    activityStatus: ActivityStatus
    searchParameter: INotificationParameter
    unreadCount: number
    hasNewItems: number
  }

  @AuthorizationStore.Action(AUTHORIZATION_FUNCTIONALITIES)
  storeGetFunctionalities: (moduleName: string) => Promise<any>;
  
  get hasNewItems(): number {
    return this.unreadNotifications.hasNewItems
  }
  get notificationItems(): IHeaderNotification[] {
    return this[this.dtActiveTab === 0 ? 'unreadNotifications' : 'notifications'].notifications
  }

  get loadingVisible(): boolean {
    return this.notifications.activityStatus === ActivityStatus.Loading
      || this.unreadNotifications.activityStatus === ActivityStatus.Loading
  }
  get unradNotificationInfinityLoadingVisible(): boolean {
    return this.dtActiveTab === 0 &&
      this.unreadNotifications.scrollable && this.unreadNotifications.activityStatus === ActivityStatus.Loaded;
  }
  get infinityLoadingVisible(): boolean {
    return this.dtActiveTab === 1 && this.notifications.scrollable && this.notifications.activityStatus === ActivityStatus.Loaded;
  }


  /**
   *
   */
  constructor() {
    super();
    this.dtPreviousDateText = null;
    this.dtActiveTab = 0;
    this.dtActiveTabs = [0, 1];
    this.dtIsDeleting = false;
    this.dtIsMarkasReadLoading = false;

  }
  get coVisible(): boolean {
    return this.visible
  }

  set coVisible(value: boolean) {
    this.$emit("update:visible", value)
  }
  get lblSetting() {
    return require('@/locales/generic-labels').default
  }

  handleBackdropClick(event) {

    if (event.target.id === 'notification-container') {
      this.$emit("update:visible", false)
    } else {
      return;
    }
  }
  getMessage(notification: IHeaderNotification) {
    if (notification.action)
      return this.$t(this.lblSetting.lblNotification[notification.action.action_type], this.getDetail(notification))
    else {
      return notification.notifDetails.description
    }
  }


  getStyle(index: number) {
    if (this.dtActiveTab === index) {
      return {
        backgroundColor: "#f92ac2"
      }
    } else {
      return {
        backgroundColor: "rgba(255,255,255,0)"
      }
    }
  }

  getTextStyle(index: number) {
    if (this.dtActiveTab === index) {
      return {
        fontWeight: 600,
        color: "#2e038c"
      }
    } else {
      return null
    }
  }

  getDetail(n: any) {
    return {
      name: n.actionOwnerName, ...n.actionDetail,
      creator: [n.creator.firstname, n.creator.lastname].join(' '),
      //manager: n.action_type === StateTypes.RemoveIc ? [n.action.actor.firstname, n.actor.lastname].join(' ') : '78'
    }
  }


  _clearTimeout: any
  handleChangeTab(tab: number) {
    this._clearTimeout = setTimeout(() => {
      this.dtActiveTab = tab;
      if (tab === 1) {
        this.storeUpdateGetNotificationsSearchParameter(0)
        setTimeout(() => this.storeGetNotifications(), 100);
      } else {
        this.storeUpdateGetUnreadNotificationsSearchParameter(0)
        setTimeout(() => this.storeGetUnreadNotifications(), 100);
      }
    }, 100);
  }

  mounted() {
    this.$watch('visible', (value) => {
      this.dtActiveTab = 0
    })
    this.$watch('$route.fullPath', (value, oldValue) => {
      this.coVisible = false;
    })
    this.storeGetFunctionalities('ticket_list')
     .then( response => {
        if(this.$route.meta) Object.keys(response).forEach( key => this.$route.meta[key] = true )
     })
  }

  handleGetMoreNotifications() {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      this.storeGetNotificationsLoadMore()
    }, 300);
  }

  handleGetMoreUnreadNotifications() {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      this.storeGetUnreadNotificationsLoadMore();
    }, 300);
  }

  async handleOnClick(event, notification: HeaderNotification) {

    if (event.type !== "ticket_action") {
      this.storeUpdateReadForSingleItem(event.id)
    }

    if (event.indexOf('agenda') > -1) {
      this.$router.push({
        path: event,
        query: {
          event_id: notification.notifDetails.ref_id,
          start_date: moment(notification.notifDetails.eventDate).format("YYYY-MM-DD")
        }
      })

      this.$emit("update:visible", false)

    } else {
      this.$router.push(event);
    }
  }

  get todayVisible(): boolean {
    return this.notificationItems.filter(x => x.daysDiff === 0).length > 0
  }
  get markAsReadVisible(): boolean {
    return this.notificationItems.filter(x => x.is_watched === false).length > 0;
  }

  get getText() {
    return this.$t('LBL_TODAY');
  }

  get notificationVisibility() {
    return this.notificationItems.length > 0
  }
  getDateText(notification: HeaderNotification, index: number) {
    let html: string = null

    if (notification.daysDiff > 0 && this.dtPreviousDateText === null || (index === 0 && notification.daysDiff > 0)) {
      this.dtPreviousDateText = notification.createdAt
      html = `<div class="notification__label pl-3 my-1" style="color: #848484; height: 20px; line-height: 20px;">${this.$t('LBL_OLDERS')}</div>`
    }

    return html
  }
  getAvatar(notification: HeaderNotification) {
    return notification.creator && notification.creator.avatar
  }

  handleMarkAllAsRead() {
    this.dtIsMarkasReadLoading = true
    this.storeMarkAllAsRead()
      .then(res => {
        this.dtIsMarkasReadLoading = false
        this.storeTicketInitUnreadMessages()
      })
      .catch(error => {
        this.dtIsMarkasReadLoading = false
      })
  }

  handleDeleteAll() {
    this.dtIsDeleting = true
    this.storeDeleteAll()
      .then(res => {
        this.dtIsDeleting = false
      })
      .catch(error => {
        this.dtIsDeleting = false
      })
  }

  handleRefreshNotifications() {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      if (this.dtActiveTab === 0) {
        this.storeGetUnreadNotifications()
      }
      else {
        this.storeGetNotifications();
      }
    }, 300);
  }
}

export default Container;



// WEBPACK FOOTER //
// ./src/components/header-notifications/index.ts